import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { AppConfigService } from '../../app-config.service';

import { PolicyDocumentType, DocumentPageType } from './types';
import { BASE_PATH_DOCUMENTS } from './constant';

@Component({
  selector: 'app-config-documents',
  templateUrl: './config-documents.component.html',
  styleUrls: ['./config-documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigDocumentsComponent {
  private readonly appConfig = inject(AppConfigService);

  @Input() set pageName(value: DocumentPageType) {
    this.documents = this.appConfig.data$.value?.documents.filter(document => document.pages.includes(value));
  }
  @Input() showPolicyLink = false;
  @Input() showNoData = true;

  documents?: PolicyDocumentType[];

  readonly basePathDocuments = BASE_PATH_DOCUMENTS;

  get appConfigData() {
    return this.appConfig.data$.value;
  }

  get visiblePolicy() {
    return this.showPolicyLink && this.appConfigData?.privacyPolicyLink;
  }

  get visibleDocuments() {
    return this.documents?.length || this.visiblePolicy;
  }
}
